<script>
import Rule from '../index';
export default {
  extends: Rule,
  computed: {
    brainUrl() {
      return '/teacher/brain-olympics';
    },
    rankUrl() {
      return '/teacher/house';
    }
  },
  methods: {
    async initPermission() {
      this.$login.teacherPermitted();
    }
  }
};
</script>
